export default __webpack_public_path__ + "static/media/home-hero.6a12cd22.jpg";